import React from "react";

function renderSegment(segment, index) {
  let content = segment.text;
  if (segment.italic) {
    content = <em key={`em-${index}`}>{content}</em>;
  }
  if (segment.bold) {
    content = <strong key={`strong-${index}`}>{content}</strong>;
  }
  return <React.Fragment key={index}>{content}</React.Fragment>;
}

/**
 * Display-only rich title. Falls back to plain text when segments are missing.
 */
function RichTitle({ segments, fallback }) {
  if (!segments?.length) {
    return <>{fallback}</>;
  }

  return <>{segments.map(renderSegment)}</>;
}

export default RichTitle;
